import { twMerge } from 'tailwind-merge';

export const Background = ({ className }: { className?: string }) => (
  <div
    className={twMerge(
      "pointer-events-none fixed inset-y-0 left-0 w-screen bg-[url('/images/background.jpg')] bg-cover bg-center",
      className
    )}
  />
);
